import { GenericStencil } from "@brexhq/metal-generic-stencil";
import * as React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import useAnalytics from "@brexhq/next/src/hooks/useAnalytics";

import { PageLoadingSkeletonShown } from "../../../telemetry/analyticsEvents";
import { GridWidth } from "../Grid";

/**
A generic page loading screen for when we dont know the underlying data shape to build more accurate stencils. Currently used before showing the 404 page and in the router.isFallback lifecycle.
 */
export const PageLoading = () => {
  return (
    <GridWidth>
      <Container
        display="flex"
        direction="column"
        gap="sml"
        padding={["lrg", "none"]}
      >
        <Container
          display="flex"
          gap="xxsml"
          overflowY="hidden"
          maxWidth="600px"
        >
          <GenericStencil width="50%" height="40px" />
          <GenericStencil width="50%" height="40px" />
        </Container>

        <GenericStencil width="100%" height="230px" />
        <GenericStencil width="100%" height="230px" />

        <Container display="flex" gap="xxsml" overflowY="hidden">
          <GenericStencil width="300px" height="120px" />
          <GenericStencil width="300px" height="120px" />
          <GenericStencil width="300px" height="120px" />
          <GenericStencil width="300px" height="120px" />
          <GenericStencil width="300px" height="120px" />
        </Container>
      </Container>
    </GridWidth>
  );
};

export const InstrumentedPageSkeleton: React.FC<{ path: string }> = ({
  path,
}) => {
  const { trackEvent } = useAnalytics();
  React.useEffect(() => {
    trackEvent(new PageLoadingSkeletonShown(path));
  }, [path, trackEvent]);
  return <PageLoading />;
};
